import React from "react";

const Footer = () => {
    return (
        <footer>
            <script src="assets/js/jquery.min.js"></script>
            <script src="assets/js/bootstrap.bundle.min.js"></script>
            <script src="assets/js/custom.js"></script>
        </footer>
    );
};

export default Footer;